module.exports = __webpack_public_path__ + "img/badge_bonus_benzina.0740b284.jpg";